import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SausagePotatoKaleSoup() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Sausage Potato Kale Soup</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 tablespoons Extra
        Virgin Olive Oil<br></br>4 Italian sausages (spicy, medium or mild),
        casings removed and discarded<br></br>2 celery stalks diced<br></br>2
        carrots diced<br></br>1 leek thinly sliced, substitute 1 yellow onion
        <br></br>2 cloves garlic thinly sliced<br></br>
        1.5 teaspoon sweet Spanish paprika<br></br>1 teaspoon dried chili flakes
        optional<br></br>
        1.5 quart chicken stock<br></br>5 small red potatoes cubed<br></br>2 bay
        leaves<br></br>1 tablespoon fresh thyme leaves<br></br>1 head kale
        roughly chopped into ribbons<br></br>2 tablespoons roughly chopped fresh
        parsley<br></br>
        Kosher salt and black pepper to taste<br></br>
      </Typography>

      <Typography>
        Preheat a large stock pot or Dutch oven over medium heat. <br></br>
        Using a paring knife, make a shallow incision along the length of the
        sausage. <br></br>
        Peel back the casings and discard them.<br></br>
        <br></br>
        Add the olive oil to the pot and heat until shimmering. <br></br>
        Add the sausage and break it apart into 1" pieces with a wooden spoon.{" "}
        <br></br>
        Cook, stirring occasionally, until browned all over, around 8 minutes.{" "}
        <br></br>
        Reserve the fat in the pan, transfer the sausage to a bowl and set
        aside.<br></br>
        <br></br>
        Add the celery, carrots and leeks and season with a pinch of salt.{" "}
        <br></br>
        Cook, stirring, until the vegetables are soft and translucent, 10-12
        minutes. <br></br>
        Add the garlic and cook, stirring, 60 seconds. <br></br>
        Add the paprika and chile flakes, if using, and cook, stirring, 60
        seconds.<br></br>
        <br></br>
        Add the stock, potatoes, browned sausage, bay leaves and thyme and stir
        to combine. <br></br>
        Bring the soup to a simmer, cover with a lid, reduce the heat to medium
        and cook until the potatoes are fork-tender, 12 to 14 minutes.<br></br>
        <br></br>
        Add the kale and cook 3-4 minutes or until wilted to desired texture.{" "}
        <br></br>
        Taste the soup for seasoning and adjust with salt and pepper as desired.{" "}
        <br></br>
        If the soup is too salty or thick, add ½ cup of water at a time until
        you reach your desired consistency and taste.<br></br>
        <br></br>
        Add the parsley and stir to combine. Ladle the soup into individual
        serving bowls and enjoy!<br></br>
      </Typography>
    </Card>
  );
}
